import styled from 'styled-components';
import { HeightProps, WidthProps } from '.';

export default styled.select`
  ${HeightProps};
  ${WidthProps};
`;
